// extracted by mini-css-extract-plugin
export default {"title":"GenerateContent_title__biaNQ","description":"GenerateContent_description__1A-46"};